import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import Fetcher from '../../common/util/Fetcher';
import PaginatedFetcher from '../../common/util/PaginatedFetcher';
import ExhaustivePaginatedFetcher from '../../common/util/ExhaustivePaginatedFetcher';
import { handleBanksResponse, handleBankResponse, handleShareBankResponse, handleShareBanksResponse } from '../../common/api/callHandlers';
import { archiveBankEntry } from '../../common/actions/bankEntries';
import { archiveBank } from '../../common/actions/banks';
import { removeSharedBank, updateSharedBankPermission as updateSharedBankPermissionAction, getSharedBanksAction } from '../../common/actions/sharedBanks';
import { sharedBankLoadingAction } from '../../common/actions/sharingModal';
import { clear, newActiveBankEntry, newActiveBank } from '../../common/actions/ui';
import t from '@instructure/quiz-i18n/format-message';
import { handleError } from '../../common/api/helpers';
import { removeFromPolling } from './copyingBanksPoller';
import { BANKS_BANK_PAGINATION, BANKS_BANK_ENTRY_PAGINATION, DELETE_BANK_CALL, UPDATE_BANK_CALL, READ_ONLY, REMOVED_ACCESS, SHARED_WITH_USER, SHARED_WITH_COURSE } from '@instructure/quiz-common';
import { noop } from 'lodash';
import { NIL } from 'uuid';
var banksApiEndpoint = '/api/banks';
var DEFAULT_PAGE_SIZE = 100;
export var simpleFetchBanks = function simpleFetchBanks() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fetcher = new PaginatedFetcher();
  return fetcher.get(banksApiEndpoint, params);
};
var _fetchBanks = function _fetchBanks(dispatch) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return simpleFetchBanks(params).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      response = _ref2[0],
      pageData = _ref2[1];
    dispatch(handleBanksResponse(response));
    return pageData;
  });
};
export var getBanks = function getBanks() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var usedByCourseEnabled = arguments.length > 1 ? arguments[1] : undefined;
  var getCourseAssignments = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    if (usedByCourseEnabled && params['course_id'] && getCourseAssignments) {
      return getCourseAssignments(params['course_id']).then(function (assignments) {
        return _fetchBanks(dispatch, _objectSpread(_objectSpread({}, params), {}, {
          quiz_ids: assignments.json.map(function (a) {
            return a.quiz_api_quiz_id;
          })
        }));
      });
    } else {
      return _fetchBanks(dispatch, params);
    }
  };
};
export var getAllBanks = function getAllBanks() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var fetcher = new ExhaustivePaginatedFetcher();
    return fetcher.get(banksApiEndpoint, _objectSpread({
      per_page: DEFAULT_PAGE_SIZE
    }, params)).then(function (response) {
      dispatch(handleBanksResponse(response));
      return response.map(function (x) {
        return x.id;
      });
    });
  };
};
export var getBank = function getBank(bankId) {
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      onError: handleError(dispatch, t('Failed to fetch bank.'))
    });
    return fetcher.get("".concat(banksApiEndpoint, "/").concat(bankId)).then(function (response) {
      return dispatch(handleBanksResponse([response]));
    })["catch"](function (err) {
      if (err.response.status === 404) {
        dispatch(clear(BANKS_BANK_PAGINATION));
      }
      // Do nothing because this case is handled elsewhere.
      // This catch is to suppress an console error for "unhandled in promise".
    });
  };
};
export var getSpecificBanks = function getSpecificBanks() {
  var bankIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      onError: handleError(dispatch, t('Failed to fetch banks.'))
    });
    var param = {
      ids: bankIds
    };
    return fetcher.get("".concat(banksApiEndpoint, "/batch_show"), param).then(function (response) {
      dispatch(handleBanksResponse(response));
      return response;
    });
  };
};
export var createBank = function createBank(newBank, shareWithCourseUuid) {
  return function (dispatch, getState) {
    var newBankData = JSON.stringify({
      bank: {
        title: newBank.title,
        language: newBank.language
      }
    });
    var fetcher = new Fetcher();
    return fetcher.post(banksApiEndpoint, {
      body: newBankData
    }).then(function (bankData) {
      dispatch([handleBankResponse(bankData), clear(BANKS_BANK_PAGINATION)]);
      if (shareWithCourseUuid) {
        simpleShareWithCourse(dispatch, bankData.id, shareWithCourseUuid);
      }
      return bankData;
    });
  };
};

// not an action creator
var simpleShareWithCourse = function simpleShareWithCourse(dispatch, bankId, courseUuid) {
  var url = "".concat(banksApiEndpoint, "/").concat(bankId, "/shared_banks");
  var shareBankData = JSON.stringify({
    shared_bank: {
      entity_id: courseUuid,
      entityType: SHARED_WITH_COURSE,
      bank_id: bankId,
      permission: READ_ONLY
    }
  });
  var fetcher = new Fetcher({
    onError: handleError(dispatch, t('Failed to share bank.'))
  });
  return fetcher.post(url, {
    body: shareBankData
  });
};
export function getExistingBankAndEntries(bankId) {
  return function (dispatch, getState) {
    return dispatch([clear("".concat(BANKS_BANK_ENTRY_PAGINATION, ":").concat(bankId)), getBank(bankId)]);
  };
}
export var updateBank = function updateBank(bank) {
  var clearPagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var url = "".concat(banksApiEndpoint, "/").concat(bank.id);
  return function (dispatch, getState) {
    var updatedBankData = JSON.stringify({
      bank: {
        title: bank.title,
        accountPermission: bank.accountPermission
      }
    });
    var fetcher = new Fetcher({
      callType: UPDATE_BANK_CALL,
      onError: handleError(dispatch, t('Failed to update bank.'))
    });
    return fetcher.patch(url, {
      body: updatedBankData
    }).then(function (bankData) {
      var toDispatch = [handleBankResponse(bankData)];
      if (clearPagination) {
        toDispatch.push(clear(BANKS_BANK_PAGINATION));
      }
      dispatch(toDispatch);
      return bankData;
    });
  };
};
export var deleteBank = function deleteBank(bankId) {
  removeFromPolling([bankId]);
  var url = "".concat(banksApiEndpoint, "/").concat(bankId);
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      callType: DELETE_BANK_CALL,
      onError: handleError(dispatch, t('Failed to delete bank.'))
    });
    return fetcher["delete"](url).then(function () {
      dispatch(clear(BANKS_BANK_PAGINATION));
      if (getState().getIn(['ui', 'activeBankId']) === bankId) {
        dispatch([newActiveBankEntry(void 0), newActiveBank(void 0)]);
      }
      var activeQuizId = getState().getIn(['quizzes', 'activeQuizId'], false);
      if (activeQuizId) {
        dispatch(archiveBank(bankId));
        getState().get('bankEntries', []).forEach(function (bankEntry) {
          if (bankEntry.get('bankId') === bankId) {
            dispatch(archiveBankEntry(bankEntry.get('id')));
          }
        });
      }
    });
  };
};
export var shareBank = function shareBank(_shareBank) {
  var getUserInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var url = "".concat(banksApiEndpoint, "/").concat(_shareBank.bankId, "/shared_banks");
  return function (dispatch, getState) {
    var shareBankData = JSON.stringify({
      shared_bank: {
        entity_id: _shareBank.entityId,
        entityType: _shareBank.entityType,
        bank_id: _shareBank.bankId,
        permission: _shareBank.permission
      }
    });
    var fetcher = new Fetcher({
      onError: handleError(dispatch, t('Failed to share bank.'))
    });
    return fetcher.post(url, {
      body: shareBankData
    }).then(function (sharedBankInfo) {
      if (_shareBank.entityType === SHARED_WITH_USER) {
        getUserInfo(sharedBankInfo.user_uuid).then(function (userInfo) {
          var sharedBank = {
            id: sharedBankInfo.id,
            entityType: SHARED_WITH_USER,
            entityId: userInfo[0].uuid,
            title: userInfo[0].fullName,
            avatar: userInfo[0].avatar,
            permission: sharedBankInfo.permission,
            bankId: _shareBank.bankId
          };
          dispatch(handleShareBankResponse(sharedBank));
        });
      } else {
        var sharedBank = {
          id: sharedBankInfo.id,
          entityType: _shareBank.entityType,
          entityId: _shareBank.entityId,
          title: _shareBank.title,
          permission: sharedBankInfo.permission,
          bankId: _shareBank.bankId
        };
        dispatch(handleShareBankResponse(sharedBank));
      }
    });
  };
};
export var getSharedBank = function getSharedBank(bankId, entityType, entityId) {
  var url = "".concat(banksApiEndpoint, "/").concat(bankId, "/shared_banks");
  var params = {
    entity_type: entityType,
    entity_id: entityId
  };
  return function (dispatch, getState) {
    var fetcher = new Fetcher({
      onError: handleError(dispatch, t('Failed to fetch shared bank.'))
    });
    return fetcher.get(url, params).then(function (sharedBankInfo) {
      // if the API returns no data, we manually add placeholder to the response
      if (sharedBankInfo.length === 0) {
        var placeholder = {
          id: "notshared_".concat(bankId, "_").concat(entityId),
          entityType: entityType,
          entityId: entityId,
          permission: REMOVED_ACCESS,
          bankId: bankId
        };
        sharedBankInfo.push(placeholder);
      }
      dispatch(handleShareBanksResponse(sharedBankInfo));
    })["catch"](function (err) {
      if (err.response.status === 401) {
        dispatch(clear(BANKS_BANK_PAGINATION));
        throw err;
      }
    });
  };
};
export var getSharedBanks = function getSharedBanks(bank, getUserInfo, getCourseInfo, getAccountInfo) {
  return function (dispatch, getState) {
    var payload = {
      bank: bank,
      getUserInfo: getUserInfo,
      getCourseInfo: getCourseInfo,
      getAccountInfo: getAccountInfo
    };
    dispatch(getSharedBanksAction(payload));
  };
};
export var changeSharedBankLoading = function changeSharedBankLoading(isLoading) {
  return function (dispatch, getState) {
    var payload = {
      loading: isLoading
    };
    dispatch(sharedBankLoadingAction(payload));
  };
};
export var updateSharedBankPermission = function updateSharedBankPermission(bankId, sharedBankId, permission) {
  var url = "".concat(banksApiEndpoint, "/").concat(bankId, "/shared_banks/").concat(sharedBankId);
  return function (dispatch, getState) {
    var shareBankData = JSON.stringify({
      shared_bank: {
        permission: permission
      }
    });
    var fetcher = new Fetcher({
      onError: handleError(dispatch, t('Failed to update shared bank permission.'))
    });
    return fetcher.patch(url, {
      body: shareBankData
    }).then(function (sharedBank) {
      if (permission === REMOVED_ACCESS) {
        dispatch(removeSharedBank(sharedBankId));
      } else {
        dispatch(updateSharedBankPermissionAction(sharedBankId, permission));
      }
    });
  };
};
export var createBankCloneJob = function createBankCloneJob(bankId) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NIL;
  var url = "".concat(banksApiEndpoint, "/").concat(bankId, "/bank_clone_jobs");
  return function (dispatch, getState) {
    var field_overrides = JSON.stringify({
      field_overrides: {
        creator: userId
      }
    });
    var fetcher = new Fetcher({
      onError: handleError(dispatch, t('Failed to create bank clone job.'))
    });
    return fetcher.post(url, {
      body: field_overrides
    });
  };
};